import {nativeRotateSupported} from './orientation_utils'

// Detects a real mobile device (phone), independent of the viewport width, by
// delegating to the shared global helper the rest of the new design relies on.
// Returns false when the helper is unavailable so callers degrade gracefully.
export const isMobileDevice = () =>
  !!(window.glg &&
     window.glg.new_design_shared &&
     typeof window.glg.new_design_shared.isMobile === 'function' &&
     window.glg.new_design_shared.isMobile())

// A webview exposing the app's rotate bridge is a phone, whatever its UA says.
export const isMobileSurface = () => isMobileDevice() || nativeRotateSupported()
